import React, { useEffect } from 'react';
import FooterSimple from '../common/footer/FooterSimple';
import HeaderPos from '../common/header/HeaderPos';
import SEO from '../common/SEO';
import BcrumbBannerOne from '../elements/breadcrumb/BcrumbBannerOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import AboutText from '../component/about/AboutText';
import TeamOne from '../component/team/TeamOne';
import ReactGA from 'react-ga';


const AboutUs = () => {

    useEffect(() => {
        ReactGA.pageview('/about-us');
    }, []);

    return (
        <>
        <SEO title="About Us" />
        <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderPos />
                <BcrumbBannerOne 
                title="Who we are? Community members,<br> just like you!"
                paragraph ="We are a team aligned with the principles and core values ​​of Cardano."
                styleClass="thumbnail-4"
                mainThumb="/images/banner/banner-thumb-3.png"
                />
                <TeamOne />
                <AboutText />
                <CtaLayoutOne />
                <FooterSimple />
            </main>
        </>
    )
}

export default AboutUs;